// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWebMembersOperationsRequestModel from '../../model/get-web-members-operations-request-model';
import GetWebMembersOperationsRequestDTO from '../dto/get-web-members-operations-request-dto';
import dtoSchema from '../schemas/get-web-members-operations-request-schema';

export default abstract class GetWebMembersOperationsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWebMembersOperationsRequestDTO>) {
    super();
    if (data) {
      this.organisationId = data.organisationId;
      this.year = data.year;
    }
  }
  /**
  * @type {uuid}
  */
  organisationId?: string;
  /**
  * @type {int32}
  */
  year?: number;

  static toModel(dto: DeepPartial<GetWebMembersOperationsRequestDTO>): GetWebMembersOperationsRequestModel;
  static toModel(dto: DeepPartial<GetWebMembersOperationsRequestDTO> | undefined | null): GetWebMembersOperationsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWebMembersOperationsRequestDTO> | undefined | null): GetWebMembersOperationsRequestModel | undefined {
    return dto ? new GetWebMembersOperationsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWebMembersOperationsRequestModel> | GetWebMembersOperationsRequestModel): GetWebMembersOperationsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      organisationId: unwrapped.organisationId,
      year: unwrapped.year,
    } as GetWebMembersOperationsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWebMembersOperationsRequestModel, can not map to GetWebMembersOperationsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
